// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Cards/WorkDetailCards/OriginalPublisherCards/OriginalPublisherCardAddWriters/WriterLabels/WriterLabel/index.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF","sourcesContent":[".button {\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
